import Vue from 'vue';
import Router from 'vue-router';
import ExhibitorDirectory from './components/ExhibitorDirectory/ExhibitorDirectory.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Directory',
      component: ExhibitorDirectory,
      meta: {
        isModalOpen: false,
      },
    },
    {
      path: '/speaker',
      name: 'Speaker',
      component: ExhibitorDirectory,
      meta: {
        isModalOpen: false,
      },
    },
    {
      path: '/speaker/:speakerId',
      name: 'SpeakerDetail',
      component: ExhibitorDirectory,
      props: true,
      meta: {
        isModalOpen: true,
      },
    },
    {
      path: '/news',
      name: 'News',
      component: ExhibitorDirectory,
      meta: {
        isModalOpen: false,
      },
    },
    {
      path: '/news/:newsId',
      name: 'NewsDetail',
      component: ExhibitorDirectory,
      props: true,
      meta: {
        isModalOpen: true,
      },
    },
    {

      path: '/program',
      name: 'FrameworkProgram',
      component: ExhibitorDirectory,
      meta: {
        isModalOpen: false,
      },
    },
    {
      path: '/program/:programId',
      name: 'FrameworkProgramDetail',
      component: ExhibitorDirectory,
      props: true,
      meta: {
        isModalOpen: true,
      },
    },
    {

      path: '/product',
      name: 'Product',
      component: ExhibitorDirectory,
      meta: {
        isModalOpen: false,
      },
    },
    {
      path: '/product/:productId',
      name: 'ProductDetail',
      component: ExhibitorDirectory,
      props: true,
      meta: {
        isModalOpen: true,
      },
    },
    {
      path: '/favourites',
      name: 'ExhibitorFavourites',
      component: ExhibitorDirectory,
      meta: {
        isModalOpen: false,
      },
    },
    {
      path: '/favouritesProgram',
      name: 'ProgramFavourites',
      component: ExhibitorDirectory,
      meta: {
        isModalOpen: false,
      },
    },
    {
      path: '/exhibitor',
      name: 'Exhibitor',
      component: ExhibitorDirectory,
      meta: {
        isModalOpen: false,
      },
    },
    {
      path: '/exhibitor/:exhibitorId',
      name: 'ExhibitorDetail',
      component: ExhibitorDirectory,
      props: true,
      meta: {
        isModalOpen: true,
      },
      // children: [
      //   {
      //     path: '/:exhibitorId/news/:newsId',
      //     name: 'ExhibitorNews',
      //     component: ExhibitorDirectory,
      //     meta: {
      //       isModalOpen: true,
      //     },
      //   },
      //   {
      //     path: '/:exhibitorId/product/:productId',
      //     name: 'ExhibitorProducts',
      //     component: ExhibitorDirectory,
      //     meta: {
      //       isModalOpen: true,
      //     },
      //   },
      // ],
    },
  ],
});
